import React from 'react';

import { flagStyles } from '../settings';

const SvgAF = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-48px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgAF;
